import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { searchAccessorialsApi } from "@tKgpco/Services/AccessorialsService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";
import { Accessorials, AccessorialsFormValues } from "@tKgpco/Store/Data/Accessorials/AccessorialsState";

type Parameters = { queryParams: Partial<AccessorialsFormValues> } & HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters, Accessorials>;

export const BeginLoadAccessorials: HandlerType = props => {
    props.dispatch({ type: "Custom/Accessorials/BeginLoad" });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await searchAccessorialsApi(props.parameter.queryParams);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const CompleteLoadAccessorials: HandlerType = props => {
    props.dispatch({
        type: "Custom/Accessorials/CompleteLoad",
        accessorials: props.apiResult,
    });
};

export const chain = [BeginLoadAccessorials, RequestDataFromApi, CompleteLoadAccessorials];

const searchAccessorials = createHandlerChainRunner(chain, "CustomSearchAccessorials");
export default searchAccessorials;
